/**
 * This file defines low level API requests to interact with the server.
 */

import axios from "axios";

const config = {
    timeout: 20 * 1000, // 20 seconds
    header: {
        'Content-Type': 'application/json'
    }
}

const handleError = (error, callback) => {
    console.error(error);
    if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        callback(error.response);
    } else if (error.request) {
        // The request was made but no response was received
        // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
        // http.ClientRequest in node.js
        callback(error.request);
    } else {
        // Something happened in setting up the request that triggered an Error
        callback(error.message);
    }
};

export const postData = (url, callback, body) => {
    let urlToUse = url;
    let csrfTokenEls = document.getElementsByName('_CSRFToken');
    if (csrfTokenEls) {
        const csrfToken = csrfTokenEls[0]?.value;
        if (csrfToken && csrfToken !== "") {
            urlToUse += `&_CSRFToken=${csrfToken}`;
        }
    }

    axios.post(urlToUse, body || {}, config)
        .then(response => {
            callback(response);
        })
        .catch(error => {
            handleError(error, callback);
        })
}

export const getData = (url, callback) => {
    axios
        .get(url, config)
        .then(response => {
            callback(response);
        })
        .catch(error => {
            handleError(error, callback);
        })
}

export const putData = (url, body, callback) => {
    axios
        .put(url, body, config)
        .then(response => callback(response))
        .catch(error => {
            callback(error);
        })
}

export const deleteData = (url, callback) => {
    axios
        .delete(url)
        .then(response => callback(response))
        .catch(error => {
            callback(error);
        })
}